<template>
  <div>
    <LoadingSpinner v-if="isLoading" />
    <div :class="{'contact-form': !isLoading, 'wide-container': !isLoading}">
      <div id="voucher-hbspt-form-target" />
    </div>
  </div>
</template>

<script lang="ts">
import LoadingSpinner from '~/core/components/shared/LoadingSpinner.vue'

import { useHBSPT } from '~/core/composable/legacy/useHBSPT'

const UUID = 'b35b0ff8-203f-4a50-b878-52c6c4d7fce0'

definePageMeta({
  layout: 'checkout',
})

export default defineNuxtComponent({
  components: {
    LoadingSpinner,
  },
  setup() {
    const {
      isLoading,
      mountForm,
    } = useHBSPT(UUID, '2453571')

    onMounted(() => {
      mountForm()
    })

    return {
      isLoading,
    }
  }
})
</script>

<style lang="scss" scoped>
.contact-form {
  @apply my-4;
  @apply px-6;

  @apply bg-white;
}

#voucher-hbspt-form-target {
  @apply pt-4;
  @apply pb-4;

  @apply overflow-visible;
}
</style>
